
import "/Applications/MAMP/htdocs/www/react+nextjs/example/ui/src/components/RightContent/AvatarDropdown.less?modules";
export default {"userInfo": `userInfo-NDBBVmDd`,"container": `container-VUJ0CDs4`,"email": `email-FyGScCT7`,"username": `username-Pcx3b05C`}
